import React from "react";
import styled from "styled-components";
import { SkeletonBox, SkeletonText } from "./SkeletonBox";

/**
 * CategoryPageSkeleton - Non-animated skeleton for Categories/Genres parent listing page
 * 
 * Matches layout of:
 * - categories/content.js (CategoriesSlider with wrapped category tiles)
 * - categoryList.js (Category tiles: 20% width, 130px min-height)
 */

var Container = styled.div`
  padding: 2rem 4rem;
  padding-bottom: 0;
  min-height: 100vh;
  background-color: #121212;
`;

var ScrollingArea = styled.div`
  background: #121212;
  -webkit-border-radius: 16px;
  -moz-border-radius: 16px;
  border-radius: 16px;
  padding: 2rem;
`;

var SectionTitle = styled.div`
  height: 27px;
  width: 150px;
  margin-bottom: 22px;
  margin-top: 1rem;
  padding-left: 60px;
  background-color: #262626;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
`;

var TilesGrid = styled.div`
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  width: 100%;
`;

var TileWrapper = styled.div`
  width: 20%;
  padding: 12px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
`;

var TileSkeleton = styled.div`
  width: 100%;
  min-height: 130px;
  background-color: #292323;
  -webkit-border-radius: 16px;
  -moz-border-radius: 16px;
  border-radius: 16px;
  padding: 2%;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -moz-box-orient: vertical;
  -moz-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -moz-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -moz-box-align: center;
  -ms-flex-align: center;
  align-items: center;
`;

var TileContent = styled.div`
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -moz-box-orient: vertical;
  -moz-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -moz-box-align: center;
  -ms-flex-align: center;
  align-items: center;
`;

/**
 * Category Tiles Grid Skeleton
 */
function CategoryTilesGridSkeleton({ count = 10 }) {
  var tiles = [];
  for (var i = 0; i < count; i++) {
    tiles.push(
      <TileWrapper key={"tile_" + i}>
        <TileSkeleton>
          <TileContent>
            <SkeletonText width={100} size="lg" style={{ marginBottom: 8 }} />
            <SkeletonText width={60} size="sm" />
          </TileContent>
        </TileSkeleton>
      </TileWrapper>
    );
  }
  
  return (
    <TilesGrid>
      {tiles}
    </TilesGrid>
  );
}

/**
 * Section with title and grid
 */
function CategorySectionSkeleton({ tileCount = 10 }) {
  return (
    <div>
      <SectionTitle />
      <CategoryTilesGridSkeleton count={tileCount} />
    </div>
  );
}

/**
 * CategoryPageSkeleton - Main export
 */
function CategoryPageSkeleton({ showCategories = true, showGenres = true }) {
  return (
    <Container>
      <ScrollingArea>
        {showCategories && <CategorySectionSkeleton tileCount={10} />}
        {showGenres && <CategorySectionSkeleton tileCount={15} />}
      </ScrollingArea>
    </Container>
  );
}

export { CategoryTilesGridSkeleton, CategorySectionSkeleton };
export default CategoryPageSkeleton;
